import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {Icon, Popover, PopoverInteractionKind, Position, Menu, MenuItem} from "@blueprintjs/core";
import { List, Map } from "immutable";
import moment from 'moment';
import Auth from '../../../lib/auth';

// Components
import VirtualizedTable from "../../../components/common/virtualized-table";
import Select from "../../../components/common/virtualized-select";
import Loading from '../../../components/common/Loading';

// Actions
import { getYears, cleanYears } from '../../../actions/years';
import { getPurchaseOrders, changePurchaseOrderStatus, cleanPurchaseOrders } from "../../../actions/purchase-orders";

const queryOptions = {
    projection: 'order_code document_date expected_delivery_date supplier statistics.subtotal statistics.vat statistics.total status',
    populateRefs: [{
        field: 'supplier',
        projection: 'basic_info.name'
    }],
    calculateStatistics: 'purchase-orders'
};

class PurchaseOrdersPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            purchaseOrderFilters: '',
            selectedYear: Auth.getSelectedYear(),
            purchaseOrdersIsFetching: false
        };
    }

    componentDidMount() {
        this.props.getYears();
        this.updateQueryOptions(this.state.selectedYear);
        this.props.getPurchaseOrders(queryOptions);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.selectedYear !== prevState.selectedYear) {
            this.updateQueryOptions(this.state.selectedYear);
            this.props.getPurchaseOrders(queryOptions);
        }
    }

    componentWillUnmount() {
        this.props.cleanPurchaseOrders();
        this.props.cleanYears();
    }

    updateQueryOptions = (selectedYear) => {
        queryOptions.filters = {
            document_date: {
                $gte: new Date(moment(selectedYear, "YYYY").startOf("year")),
                $lt: new Date(moment(selectedYear, "YYYY").endOf("year"))
            }
        };
    };

    onChangeYear = (year) => {
        this.setState({
            selectedYear: year
        });

        Auth.setSelectedYear(year);
    };

    getPurchaseOrder = (purchaseOrderId) => {
        const { purchaseOrders } = this.props;
        const index = purchaseOrders.findIndex( purchaseOrder => purchaseOrder.get('_id') === purchaseOrderId );

        return purchaseOrders.get(index);
    };

    render() {
        const yearOptions = this.props.years || List([Map({ year: moment().year })]);
        
        // Stats Zone
        let totalOrders = 0;
        const purchaseOrdersIsFetching = this.props.purchaseOrdersIsFetching;

        this.props.purchaseOrders.forEach(order => totalOrders = totalOrders + order.getIn(['statistics', 'total']));

        // PurchaseOrders Table
        let tableData = this.props.purchaseOrders;
        let tableSettings = {
            showFooter: true,
            sortable: true,
            filterable: true,
            defaultSortFields: [],
            defaultSortDirections: ['asc'],
            height: tableData.size < 17 ? tableData.size * 40 : 680,
            rowHeight: 40,
            strippedRows: false
        };
        let tableColumns = {
            order_code: {
                title: 'Código',
                columnType: 'function',
                dataField: ['_id', 'order_code'],
                width: 100,
                style: {},
                sortable: true,
                sortableIndex: 1,
                filterable: true,
                filterableIndex: 1,
                nodeContent: (value) => {
                    return <Link to={ '/compras/pedidos/' + value[0] }>{ value[1] }</Link>
                }
            },
            document_date: {
                title: "Fecha",
                columnType: 'date',
                dataField: 'document_date',
                width: 100,
                style: {},
                sortable: true,
                filterable: true,
                format: 'DD/MM/YYYY'
            },
            expected_delivery_date: {
                title: "Fecha prevista de entrega",
                columnType: 'date',
                dataField: 'expected_delivery_date',
                width: 200,
                style: {},
                sortable: true,
                filterable: true,
                format: 'DD/MM/YYYY'
            },
            supplier: {
                title: "Proveedor",
                columnType: 'text',
                dataField: 'supplier',
                width: 200,
                style: {},
                sortable: true,
                filterable: true,
            },
            subtotal: {
                title: "Subtotal",
                columnType: 'number',
                dataField: 'statistics.subtotal',
                width: 150,
                style: {textAlign: 'right'},
                sortable: true,
                filterable: true,
                footer: { type: 'operation', value: 'sum' }
            },
            vat: {
                title: "IVA",
                columnType: 'number',
                dataField: 'statistics.vat',
                width: 150,
                style: {textAlign: 'right'},
                sortable: true,
                filterable: true,
                footer: { type: 'operation', value: 'sum' }
            },
            total: {
                title: "Total",
                columnType: 'number',
                dataField: 'statistics.total',
                width: 150,
                style: {textAlign: 'right'},
                sortable: true,
                filterable: true,
                footer: { type: 'operation', value: 'sum' }
            },
            status: {
                title: "Estado",
                columnType: 'function',
                dataField: 'status',
                width: 100,
                style: {},
                sortable: false,
                filterable: false,
                nodeContent: (status) => {
                    let data = { badgeColor: '', value: '' };

                    switch (status) {
                        case 'pending':
                            data.badgeColor = 'danger';
                            data.value = 'Pendiente';
                            break;
                        case 'requested':
                            data.badgeColor = 'warning';
                            data.value = 'Solicitado';
                            break;
                        case 'partial':
                            data.badgeColor = 'warning-light';
                            data.value = 'Parcial';
                            break;
                        case 'received':
                            data.badgeColor = 'primary';
                            data.value = 'Recibido';
                            break;
                        case 'invoiced':
                            data.badgeColor = 'success';
                            data.value = 'Facturado';
                            break;
                        default:
                            break;
                    }

                    return (
                        <div>
                            <span className={'badge badge-' + data.badgeColor}>
                                {data.value}
                            </span>
                        </div>
                    );
                }
            },
            actions: {
                title: '',
                columnType: 'function',
                dataField: '_id',
                width: 30,
                style: { alignItems: 'center', maxWidth: 30 },
                sortable: false,
                filterable: false,
                nodeContent: (purchaseOrderId) => {
                    const purchaseOrder = this.getPurchaseOrder(purchaseOrderId);
                    let popoverContent = (<Menu></Menu>);

                    switch (purchaseOrder.get('status')) {
                        case 'pending':
                            popoverContent = (
                                <Menu>
                                    <MenuItem icon="eye-open" text="Ver detalle" onClick={ () => this.props.history.push('/compras/pedidos/' + purchaseOrder.get('_id'))} />
                                    <MenuItem icon="swap" text="Solicitado" onClick={ () => this.props.changePurchaseOrderStatus(purchaseOrderId, 'requested', queryOptions) } />
                                    <MenuItem icon="swap" text="Parcial" onClick={ () => this.props.changePurchaseOrderStatus(purchaseOrderId, 'partial', queryOptions) } />
                                    <MenuItem icon="swap" text="Recibido" onClick={ () => this.props.changePurchaseOrderStatus(purchaseOrderId, 'received', queryOptions) } />
                                    <MenuItem icon="swap" text="Facturado" onClick={ () => this.props.changePurchaseOrderStatus(purchaseOrderId, 'invoiced', queryOptions) } />
                                </Menu>
                            );
                            break;
                        case 'requested':
                            popoverContent = (
                                <Menu>
                                    <MenuItem icon="eye-open" text="Ver detalle" onClick={ () => this.props.history.push('/compras/pedidos/' + purchaseOrder.get('_id'))} />
                                    <MenuItem icon="swap" text="Pendiente" onClick={ () => this.props.changePurchaseOrderStatus(purchaseOrderId, 'pending', queryOptions) } />
                                    <MenuItem icon="swap" text="Parcial" onClick={ () => this.props.changePurchaseOrderStatus(purchaseOrderId, 'partial', queryOptions) } />
                                    <MenuItem icon="swap" text="Recibido" onClick={ () => this.props.changePurchaseOrderStatus(purchaseOrderId, 'received', queryOptions) } />
                                    <MenuItem icon="swap" text="Facturado" onClick={ () => this.props.changePurchaseOrderStatus(purchaseOrderId, 'invoiced', queryOptions) } />
                                </Menu>
                            );
                            break;
                        case 'partial':
                            popoverContent = (
                                <Menu>
                                    <MenuItem icon="eye-open" text="Ver detalle" onClick={ () => this.props.history.push('/compras/pedidos/' + purchaseOrder.get('_id'))} />
                                    <MenuItem icon="swap" text="Pendiente" onClick={ () => this.props.changePurchaseOrderStatus(purchaseOrderId, 'pending', queryOptions) } />
                                    <MenuItem icon="swap" text="Solicitado" onClick={ () => this.props.changePurchaseOrderStatus(purchaseOrderId, 'requested', queryOptions) } />
                                    <MenuItem icon="swap" text="Recibido" onClick={ () => this.props.changePurchaseOrderStatus(purchaseOrderId, 'received', queryOptions) } />
                                    <MenuItem icon="swap" text="Facturado" onClick={ () => this.props.changePurchaseOrderStatus(purchaseOrderId, 'invoiced', queryOptions) } />
                                </Menu>
                            );
                            break;
                        case 'received':
                            popoverContent = (
                                <Menu>
                                    <MenuItem icon="eye-open" text="Ver detalle" onClick={ () => this.props.history.push('/compras/pedidos/' + purchaseOrder.get('_id'))} />
                                    <MenuItem icon="swap" text="Pendiente" onClick={ () => this.props.changePurchaseOrderStatus(purchaseOrderId, 'pending', queryOptions) } />
                                    <MenuItem icon="swap" text="Solicitado" onClick={ () => this.props.changePurchaseOrderStatus(purchaseOrderId, 'requested', queryOptions) } />
                                    <MenuItem icon="swap" text="Parcial" onClick={ () => this.props.changePurchaseOrderStatus(purchaseOrderId, 'partial', queryOptions) } />
                                    <MenuItem icon="swap" text="Facturado" onClick={ () => this.props.changePurchaseOrderStatus(purchaseOrderId, 'invoiced', queryOptions) } />
                                </Menu>
                            );
                            break;
                        case 'invoiced':
                            popoverContent = (
                                <Menu>
                                    <MenuItem icon="eye-open" text="Ver detalle" onClick={ () => this.props.history.push('/compras/pedidos/' + purchaseOrder.get('_id'))} />
                                    <MenuItem icon="swap" text="Pendiente" onClick={ () => this.props.changePurchaseOrderStatus(purchaseOrderId, 'pending', queryOptions) } />
                                    <MenuItem icon="swap" text="Solicitado" onClick={ () => this.props.changePurchaseOrderStatus(purchaseOrderId, 'requested', queryOptions) } />
                                    <MenuItem icon="swap" text="Parcial" onClick={ () => this.props.changePurchaseOrderStatus(purchaseOrderId, 'partial', queryOptions) } />
                                    <MenuItem icon="swap" text="Recibido" onClick={ () => this.props.changePurchaseOrderStatus(purchaseOrderId, 'received', queryOptions) } />
                                </Menu>
                            );
                            break;
                        default:
                            break;
                    }

                    return (
                        <div>
                            <Popover
                                content={popoverContent}
                                interactionKind={PopoverInteractionKind.CLICK}
                                position={Position.LEFT_BOTTOM}
                            >
                                <Icon
                                    className="icon-custom"
                                    title={false}
                                    icon={'more'}
                                    iconSize={18}
                                    color="#183650"
                                />
                            </Popover>
                        </div>
                    );
                }
            }
        };

        // Filters
        let statsZone = (
            <div className="row stats-zone" style={{ marginBottom: 20 }} >
                <div className="col-auto">
                    <span className="label "><strong>{ this.props.purchaseOrders.size || 0 }</strong></span>
                    <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: '' }) }>
                        <strong>Pedidos</strong>
                    </span>
                </div>
                <div className="col-auto">
                    <span className="label label-danger">{ this.props.purchaseOrders.count(order => order.get('status') === 'pending') }</span>
                    <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'pending' }) }>Pendientes</span>
                </div>
                <div className="col-auto">
                    <span className="label label-warning">{ this.props.purchaseOrders.count(order => order.get('status') === 'requested') }</span>
                    <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'requested' }) }>Solicitados</span>
                </div>
                <div className="col-auto">
                    <span className="label label-warning-light">{ this.props.purchaseOrders.count(order => order.get('status') === 'partial') }</span>
                    <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'partial' }) }>Parciales</span>
                </div>
                <div className="col-auto">
                    <span className="label label-primary">{ this.props.purchaseOrders.count(order => order.get('status') === 'received') }</span>
                    <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'received' }) }>Recibidos</span>
                </div>
                <div className="col-auto">
                    <span className="label label-success">{ this.props.purchaseOrders.count(order => order.get('status') === 'invoiced') }</span>
                    <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'invoiced' }) }>Facturados</span>
                </div>
            </div>
        );
        switch (this.state.purchaseOrderFilters) {
            case 'pending':
                statsZone = (
                    <div className="row stats-zone" style={{ marginBottom: 20 }} >
                        <div className="col-auto">
                            <span className="label ">{ this.props.purchaseOrders.size || 0 }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: '' }) }>
                                Pedidos
                            </span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-danger">
                                <strong>{ this.props.purchaseOrders.count(order => order.get('status') === 'pending') }</strong>
                            </span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'pending' }) }>
                                <strong>Pendientes</strong>
                            </span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-warning">{ this.props.purchaseOrders.count(order => order.get('status') === 'requested') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'requested' }) }>Solicitados</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-warning-light">{ this.props.purchaseOrders.count(order => order.get('status') === 'partial') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'partial' }) }>Parciales</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-primary">{ this.props.purchaseOrders.count(order => order.get('status') === 'received') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'received' }) }>Recibidos</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-success">{ this.props.purchaseOrders.count(order => order.get('status') === 'invoiced') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'invoiced' }) }>Facturados</span>
                        </div>
                    </div>
                );
                tableData = this.props.purchaseOrders.filter( purchaseOrder => purchaseOrder.get('status') === 'pending' );
                break;
            case 'requested':
                statsZone = (
                    <div className="row stats-zone" style={{ marginBottom: 20 }} >
                        <div className="col-auto">
                            <span className="label ">{ this.props.purchaseOrders.size || 0 }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: '' }) }>
                                Pedidos
                            </span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-danger">{ this.props.purchaseOrders.count(order => order.get('status') === 'pending') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'pending' }) }>Pendientes</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-warning">
                                <strong>{ this.props.purchaseOrders.count(order => order.get('status') === 'requested') }</strong>
                            </span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'requested' }) }>
                                <strong>Solicitados</strong>
                            </span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-warning-light">{ this.props.purchaseOrders.count(order => order.get('status') === 'partial') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'partial' }) }>Parciales</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-primary">{ this.props.purchaseOrders.count(order => order.get('status') === 'received') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'received' }) }>Recibidos</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-success">{ this.props.purchaseOrders.count(order => order.get('status') === 'invoiced') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'invoiced' }) }>Facturados</span>
                        </div>
                    </div>
                );
                tableData = this.props.purchaseOrders.filter( purchaseOrder => purchaseOrder.get('status') === 'requested' );
                break;
            case 'partial':
                statsZone = (
                    <div className="row stats-zone" style={{ marginBottom: 20 }} >
                        <div className="col-auto">
                            <span className="label ">{ this.props.purchaseOrders.size || 0 }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: '' }) }>
                                Pedidos
                            </span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-danger">{ this.props.purchaseOrders.count(order => order.get('status') === 'pending') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'pending' }) }>Pendientes</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-warning">{ this.props.purchaseOrders.count(order => order.get('status') === 'requested') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'requested' }) }>Solicitados</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-warning-light">
                                <strong>{ this.props.purchaseOrders.count(order => order.get('status') === 'partial') }</strong>
                            </span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'partial' }) }>
                                <strong>Parciales</strong>
                            </span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-primary">{ this.props.purchaseOrders.count(order => order.get('status') === 'received') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'received' }) }>Recibidos</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-success">{ this.props.purchaseOrders.count(order => order.get('status') === 'invoiced') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'invoiced' }) }>Facturados</span>
                        </div>
                    </div>
                );
                tableData = this.props.purchaseOrders.filter( purchaseOrder => purchaseOrder.get('status') === 'partial' );
                break;
            case 'received':
                statsZone = (
                    <div className="row stats-zone" style={{ marginBottom: 20 }} >
                        <div className="col-auto">
                            <span className="label ">{ this.props.purchaseOrders.size || 0 }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: '' }) }>
                                Pedidos
                            </span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-danger">{ this.props.purchaseOrders.count(order => order.get('status') === 'pending') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'pending' }) }>Pendientes</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-warning">{ this.props.purchaseOrders.count(order => order.get('status') === 'requested') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'requested' }) }>Solicitados</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-warning-light">{ this.props.purchaseOrders.count(order => order.get('status') === 'partial') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'partial' }) }>Parciales</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-primary">
                                <strong>{ this.props.purchaseOrders.count(order => order.get('status') === 'received') }</strong>
                            </span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'received' }) }>
                                <strong>Recibidos</strong>
                            </span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-success">{ this.props.purchaseOrders.count(order => order.get('status') === 'invoiced') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'invoiced' }) }>Facturados</span>
                        </div>
                    </div>
                );
                tableData = this.props.purchaseOrders.filter( purchaseOrder => purchaseOrder.get('status') === 'received' );
                break;
            case 'invoiced':
                statsZone = (
                    <div className="row stats-zone" style={{ marginBottom: 20 }} >
                        <div className="col-auto">
                            <span className="label ">{ this.props.purchaseOrders.size || 0 }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: '' }) }>
                                Pedidos
                            </span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-danger">{ this.props.purchaseOrders.count(order => order.get('status') === 'pending') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'pending' }) }>Pendientes</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-warning">{ this.props.purchaseOrders.count(order => order.get('status') === 'requested') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'requested' }) }>Solicitados</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-warning-light">{ this.props.purchaseOrders.count(order => order.get('status') === 'partial') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'partial' }) }>Parciales</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-primary">{ this.props.purchaseOrders.count(order => order.get('status') === 'received') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'received' }) }>Recibidos</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-success">
                                <strong>{ this.props.purchaseOrders.count(order => order.get('status') === 'invoiced') }</strong>
                            </span>
                            <span className="handPointer" onClick={ () => this.setState({ purchaseOrderFilters: 'invoiced' }) }>
                                <strong>Facturados</strong>
                            </span>
                        </div>
                    </div>
                );
                tableData = this.props.purchaseOrders.filter( purchaseOrder => purchaseOrder.get('status') === 'invoiced' );
                break;
            default :
                break;
        }

        return (
            <div id="page-wrapper" className="gray-bg">
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col d-flex align-items-center">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/compras/resumen">Compras</Link>
                            </li>
                            <li className="breadcrumb-item active">
                                <strong>Pedidos</strong>
                            </li>
                        </ol>
                    </div>
                    <div className="col d-flex align-items-center justify-content-end">
                        <div className="title-action">
                            <button className="btn btn-primary" onClick={ () => this.props.history.push('/compras/pedidos/nuevo') } > <Icon icon="insert"/>Pedido</button>
                        </div>
                        <div className="title-action">
                            <Select
                                style={{ width: 75, marginLeft: 20 }}
                                options={yearOptions.toJS()}
                                value={this.state.selectedYear}
                                labelKey='year'
                                valueKey='year'
                                matchProp='year'
                                multi={false}
                                searchable={true}
                                clearable={false}
                                onChange={(selectedValue) => { if (selectedValue) this.onChangeYear(selectedValue.year) }}
                            />
                        </div>
                    </div>
                </div>
                <div className="wrapper wrapper-content">
                    {statsZone}
                    <div className="row">
                        <div className="col">
                            <div className="ibox">
                                <div className="ibox-content">
                                    {purchaseOrdersIsFetching ? (
                                        <Loading show={purchaseOrdersIsFetching} />
                                    ) : (
                                        <VirtualizedTable
                                            tableSettings={tableSettings}
                                            tableColumns={tableColumns}
                                            tableData={tableData}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    // Reducers
    const yearsReducer = state.years;
    const purchaseOrdersReducer = state.purchaseOrders;

    // Years
    let years = yearsReducer.get('payload') || List([]);

    if (!(years instanceof List)) {
        years = List([])
    }

    // PurchaseOrders
    let purchaseOrders = purchaseOrdersReducer.get('payload') || List([]);
    const purchaseOrdersIsFetching = purchaseOrdersReducer.get('isFetching');

    if (!(purchaseOrders instanceof List)) {
        purchaseOrders = List([])
    }

    return {
        years,
        purchaseOrders,
        purchaseOrdersIsFetching
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getYears: () => dispatch(getYears()),
        getPurchaseOrders: (query) => dispatch(getPurchaseOrders(query)),
        changePurchaseOrderStatus: (purchaseOrderId, status, options) => dispatch(changePurchaseOrderStatus(purchaseOrderId, status, options)),
        cleanPurchaseOrders: () => dispatch(cleanPurchaseOrders()),
        cleanYears: () => dispatch(cleanYears()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseOrdersPage);


// WEBPACK FOOTER //
// ./src/containers/purchases/orders/PurchaseOrdersPage.js